// PrivacyPolicy.jsx
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  const containerStyles = {
    marginLeft: '40px',
    marginRight: '20px',
  };

  const headingStyles = {
    color: 'yellow',
    marginTop: '20px',
  };

  const textStyles = {
    color: 'white',
  };

  return (
    <div className="flex flex-col bg-black">
        <header className="bg-black text-white px-4 py-6 w-full">
          <h2 className="text-xl lg:text-2xl text-yellow-200 font-bold text-center">
            Think5Whys Privacy Policy
          </h2>
        </header>
      <div className="mx-auto px-4 py-8 bg-black text-white shadow-lg rounded-lg">
        <p className="text-gray-300 text-lg font-semibold mb-4">
          Effective Date: 01 August 2026
        </p>

        <p className="text-base text-gray-100  leading-7 mb-6">
          Welcome to <span className="font-bold">Think5Whys Global DeepTech Services, Mumbai, India</span>! At Think5Whys, we respect and value your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you visit our website.
        </p>

        <h2 className="text-lg lg:text-xl text-cyan-200  font-bold mb-4">1. Information We Collect</h2>
        <p className="text-base text-gray-100  leading-7 mb-6">
          We may collect personal information, such as your name, email address, and other contact details when you voluntarily provide them through our website.
        </p>

        <h2 className="text-lg lg:text-xl text-cyan-200  font-bold mb-4">2. Use of Information</h2>
        <p className="text-base text-gray-100  leading-7 mb-6">
          We use the collected information to enhance your experience, provide personalized content, improve our website, and communicate with you. We do not sell, trade, or transfer your personal information to third parties.
        </p>

        <h2 className="text-lg lg:text-xl text-cyan-200  font-bold mb-4">3. Cookies</h2>
        <p className="text-base text-gray-100  leading-7 mb-6">
          Our website uses cookies to enhance your browsing experience. You can adjust your browser settings to refuse cookies or notify you when cookies are being sent. However, this may impact some functionalities of the site.
        </p>

        <h2 className="text-lg lg:text-xl text-cyan-200  font-bold mb-4">4. Third-Party Links</h2>
        <p className="text-base text-gray-100  leading-7 mb-6">
          Our website may contain links to third-party websites. We have no control over their content or privacy practices, and we encourage you to review their privacy policies before providing any personal information.
        </p>

        <h2 className="text-lg lg:text-xl text-cyan-200  font-bold mb-4">5. Data Security</h2>
        <p className="text-base text-gray-100  leading-7 mb-6">
          We implement reasonable security measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction.
        </p>

        <h2 className="text-lg lg:text-xl text-cyan-200  font-bold mb-4">6. Changes to Privacy Policy</h2>
        <p className="text-base text-gray-100  leading-7 mb-6">
          We may update our Privacy Policy to reflect changes in our practices. It is your responsibility to review this page periodically for any updates.
        </p>

        <h2 className="text-lg lg:text-xl text-cyan-200  font-bold mb-4">7. Contact Us</h2>
        <p className="text-base text-gray-100  leading-7 mb-6">
          If you have any questions or concerns regarding our Privacy Policy, please contact us at <span className="font-semibold">contact@think5whys.com</span>.
        </p>

        <p className="text-base text-gray-100  leading-7">
          Thank you for trusting Think5Whys Global DeepTech Services, Mumbai, India with your information.
        </p>
      </div>
      <footer className="bg-black border-t border-blue-800 text-white py-4 w-full mt-auto">
        <div className="w-full px-2 sm:px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-xs sm:text-sm lg:text-lg text-yellow-200 text-center md:text-left break-words">
              © {new Date().getFullYear()} Think5Whys Global DeepTech Solutions.
            </div>
            <nav className="flex flex-wrap justify-center md:justify-end gap-2 sm:gap-4 text-xs sm:text-sm">
              <Link to="/about-us" className="text-white hover:text-yellow-200">About</Link>
              <Link to="/privacy-policy" className="text-white hover:text-yellow-200">Privacy Policy</Link>
              <Link to="/terms-of-use" className="text-white hover:text-yellow-200">Terms of Use</Link>
              <Link to="/contact-us" className="text-white hover:text-yellow-200">Contact</Link>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
